/** @jsx jsx */
import { Flex, jsx } from 'theme-ui';
import styled from '@emotion/styled';
import FooterLogo from '../logo/footerAltLogo';

import themeHarrys from '../../gatsby-plugin-theme-ui';
import themeLume from '../../gatsby-plugin-theme-ui-lume';
import themeMando from '../../gatsby-plugin-theme-ui-mando';
import themeHaven from '../../gatsby-plugin-theme-ui-haven';
import themeSpruce from '../../gatsby-plugin-theme-ui-spruce';

function generateBrandSpecificComponents (brand) {
  var theme;

  var containerBrandStyle = '',
      containerChildrenBrandStyle = '';
      
  switch(brand) {
    case 'kelly':
      theme = themeHaven;
      containerBrandStyle = `
        color: ${theme.referenceColors.body};
        background-color: ${theme.referenceColors.background};
      `;
      containerChildrenBrandStyle = `
        a {
          color: #333333;
        }
        a:hover {
          color: #CBBAB0;
        }
      `;
      break;
    case 'spruce':
        theme = themeSpruce;
        containerBrandStyle = `
          color: #333333;
          background-color: #f0f4fb;
          border-top: 3px solid #3c519d;
          height: auto;
          min-height: 10em;
          padding: 2.4em 1em;
        `;
        containerChildrenBrandStyle = `
          display: flex;
          flex-direction: column;
          align-items: center;
          h2 {
            font-family: ${theme.fonts.heading};
            font-size: 20px;
            font-weight: 600;
            letter-spacing: 0.02em;
            color: #000;
          }
          a {
            color: #333333;
          }
          a:hover {
            color: #3c519d;
          }
          img {
            display: block;
            margin-left: auto;
            margin-right: auto;
          }
        `;
        break;  
    case 'harrys':
      theme = themeHarrys;
      containerBrandStyle = `
        color: #fff;
      `;
      containerChildrenBrandStyle = `
        a {
          color: #fff;
        }
      `;
      break;
    case 'lume':
      theme = themeLume;
      containerBrandStyle = `
        color: #fff;
        background-color: #009f9d;
      `;
      containerChildrenBrandStyle = `
        a {
          color: #fff;
        }
      `;
      break;
    case 'mando':
      theme = themeMando;
      containerBrandStyle = `
        color: #fff;
        background-color: ${theme.referenceColors.background};
      `;
      containerChildrenBrandStyle = `
        .footerCol {
          display: inline-block;
          width: 25%;
          max-width: 400px;
          text-align: left;
          vertical-align: top;
          font-family: Roboto;
          font-size: 16px;
          color: rgba(255,255,255,0.75);
          padding: 10px;
        }
        .footerCol.logo {
          text-align: center;
        }
        .footerCol h2 {
          font-weight: bold;
          font-size: 18px;
          font-family: Blender;
          margin-bottom: 15px;
          color: #fff;
        }
        .footerCol a {
          color: rgba(255,255,255,0.75);
          font-family: Roboto;
          font-size: 14px;
        }
        .footerCol a:hover {
          text-decoration: underline;
        }

        @media only screen and (max-width: 500px) {
          height: 650px;
          .footerCol {
            display: block;
            width: 100%;
          }
          .footerCol.logo {
            margin-bottom: 20px;
          }
        }
      `;
      break;
  } 

  const brandColors = theme.referenceColors;

  const Container = styled.footer`
    background-color: ${brandColors.heading};    
    font-size: ${theme.fontSizes[1]}px;
    padding: 1em;
    text-align: center;
    width: 100%;
    height: ${theme.sizes.footerHeight};

    ${containerBrandStyle}

    && {
      a {
        font-family: GT America;
        font-weight: 500;
        font-size: 12px;
        font-style: normal;
        text-decoration: none;
        letter-spacing: -0.05px;
        &:hover {
          text-decoration: none;
        }
      }

      ${containerChildrenBrandStyle}
    }
  `;
  return Container
}

const Footer = ({ regionConfig }) => {
  var Container = generateBrandSpecificComponents (regionConfig.brand)

  switch(regionConfig.brand){
    case 'kelly':
      return (
        <Container>
          {/* <FooterLogo regionConfig={regionConfig} /> */}
          <br></br>
          <h2>Haven Health</h2>
        </Container>
      );
    case 'spruce':
        return (
          <Container>
            <img width="200px" src="https://cdn.builder.io/api/v1/image/assets%2Ff9dd6bab38b6461a948dbc919c8394de%2F56e2fde36c184a5d9694164eec8ddb91"></img>
          </Container>
        );
    case 'harrys':
      return (
        <Container>
          <FooterLogo regionConfig={regionConfig} />
          <br />
          {regionConfig.copyrightText}
          <br />
          {regionConfig.footerLinks
            .map((link) => {
              return (
                <a key={link.url} href={`https://${regionConfig.domain}${link.url}`}>
                  {link.title}
                </a>
              );
            })
            .reduce((prev, curr) => [prev, ' / ', curr])}
        </Container>
      );
    case 'lume':
      return (
        <Container>
          <FooterLogo regionConfig={regionConfig} />
          <br />
          {regionConfig.footerLinks
            .map((link) => {
              return (
                <a key={link.url} href={`${link.url}`}>
                  {link.title}
                </a>
              );
            })
            .reduce((prev, curr) => [prev, ' | ', curr])}
        </Container>
      );
    case 'mando':
      return (
        <Container>
          <div className="footerCol logo">
            <FooterLogo regionConfig={regionConfig} />
          </div>
          <div className="footerCol">
            <h2>Money Back Guarantee</h2>
            If Mando isn't for you, we'll gladly refund your order within 60 days of purchase.
          </div>
          <div className="footerCol">
            <h2>Free Shipping</h2>
            Mando offers FREE first class shipping throughout the United States. To qualify, order must total $25 before taxes.
          </div>
          <div className="footerCol">
            <h2>Info</h2>
            {regionConfig.footerLinks
              .map((link) => {
                return (
                  <a key={link.url} href={`${link.url}`}>
                    {link.title}<br/>
                  </a>
                );
              })
            }
          </div>
        </Container>
      );
  }
};

export default Footer;
